import { useCallback, useMemo } from 'react';

// Hook responsible for updating and reloading Ag Grid column state.
export const useColumnStateInStore = ({
  gridApi,
  updateColumnState,
  columnState,
}) => {
  const onColumnStateChange = useCallback(() => {
    updateColumnState({ columns: gridApi.getColumnState(), columnGroups: gridApi.getColumnGroupState() });
  }, [updateColumnState, gridApi]);

  const reloadColumnStateFromStore = useCallback(() => {
    if (gridApi) {
      if (columnState.columns) {
        gridApi.applyColumnState({ state: columnState.columns, applyOrder: true });
      }
      if (columnState.columnGroupState) {
        gridApi.applyColumnState({ state: columnState.columnGroupState, applyOrder: true });
      }
    }
  }, [gridApi, columnState]);

  return useMemo(() => ({
    onSortChanged: onColumnStateChange,
    onFilterChanged: onColumnStateChange,
    reloadColumnStateFromStore,
  }), [
    onColumnStateChange,
    reloadColumnStateFromStore,
  ]);
};
